export default '5.7.0';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch-core/dist/es/core/version.js
// module id = 253
// module chunks = 0